import { api, unwrap } from './index';

const PAGE_FOR = { media: '/watch/', event: '/events/', fighter: '/fighters/' };

/**
 * `GET /v1/resolve` for a path this app could not load as given: a retired slug, a merged
 * fighter's slug, or a legacy Webflow item id (`is_retired_slug: true`).
 * @param {string} path e.g. `/fighters/68b1f2c4a91d4e5f70123402`
 * @returns {Promise<string | null>} the canonical web path, or null when nothing resolves
 */
export async function resolvePath(path) {
  try {
    const { data } = await unwrap(api.GET('/v1/resolve', { params: { query: { path } } }));
    const { entity_type: type, slug, id } = data.resolved;
    return PAGE_FOR[type] ? `${PAGE_FOR[type]}${slug || id}` : null;
  } catch (error) {
    if (error.code !== 'NOT_FOUND') {
      console.error('GET /v1/resolve failed:', error);
    }
    return null;
  }
}
